import { useApp } from 'contexts/app';
import PageLayout from 'pages/CreateAssignment/PageLayout';
import PageProvider from 'pages/EditAssignment/PageProvider';
import { Loading } from 'shell/components';

const EditAssignmentPage = ({ ...props }) => {
    const { isLoading } = useApp();

    return isLoading ? (
        <Loading />
    ) : (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default EditAssignmentPage;
